import styled from 'styled-components';
import COLORS from '../../colors';
import { RootState } from '../../redux/store';
import { REDUX_KEY } from '../../redux/constants';
import { updateField } from '../../redux/features/campaignDetail/campaignDetailSlice';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { Input } from '../Input';

const NotesWrapper = styled.div`
  margin: 32px 0;
  padding: 16px 16px 32px 16px;
  background-color: ${COLORS.NEUTRAL_925};
  border-radius: 16px;
`;

const Header = styled.h2`
  margin-bottom: 16px;
  margin-top: 16px;
`;

const NotesInnerWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

const NotesText = styled.p`
  color: ${COLORS.NEUTRAL_300};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin-right: 32px;
  width: 600px;
`;

const CampaignNotes = () => {
  const dispatch = useAppDispatch();

  const { campaignNotes } = useAppSelector((state: RootState) => state.detail);

  const handleChange = (fieldName: string, value: string | number) => {
    const updatedField = updateField({
      fieldName,
      value
    });

    dispatch(updatedField);
  };

  return (
    <NotesWrapper>
      <Header>Campaign Notes</Header>
      <NotesInnerWrapper>
        <NotesText>
          Let us know about any creative restrictions, such as alcohol, or key
          campaign info like launch time.
        </NotesText>
        <Input
          label="Campaign Notes"
          value={campaignNotes}
          onChange={(value: string) =>
            handleChange(REDUX_KEY.CAMPAIGN_NOTES, value)
          }
          helperText="Maximum of 1000 characters"
          multiline
        />
      </NotesInnerWrapper>
    </NotesWrapper>
  );
};

export default CampaignNotes;
